import Axios  from "axios"

export const getFarms = (farms) => async (dispatch) => {
    dispatch({
        type: 'FARM_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/farm/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'FARMS_GET_SUCCESS',
                payload: data.farms
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'FARM_ERROR'           
        })         
    }
}

export const getFarmDetail = (farm) => async (dispatch) => {
    dispatch({
        type: 'FARM_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/farm/get/'+ farm, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'FARM_GET_DETAIL_SUCCESS',
                payload: data.farm
            })             
        }

    } catch (error) {
        dispatch({
            type: 'FARM_ERROR'           
        })         
    }
}

export const addFarm = (name, origen, latitude, longitude) => async (dispatch) => {
    dispatch({
        type: 'FARM_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/farm/register', {
                name: name,
                origen: origen,
                latitude: latitude,
                longitude: longitude
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newFarm = {
                _id: data.id,
                name: name,
                origen: origen,
                latitude: latitude,
                longitude: longitude
            }
            dispatch({
                type: 'FARM_ADD_SUCCESS',
                payload: newFarm
            })
        }
    } catch (error) {
        dispatch({
            type: 'FARM_FAIL'
        })
    }
}

export const editFarm = (name, origen, latitude, longitude, idFarm) => async (dispatch) => {
    dispatch({
        type: 'FARM_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/farm/edit/' + idFarm, {
                name: name,
                origen: origen,
                latitude: latitude,
                longitude: longitude
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'FARM_EDIT_SUCCESS',
            payload: {
                name: name,
                origen: origen,
                latitude: latitude,
                longitude: longitude,
                _id: idFarm
            }
        })
    } catch (error) {
        dispatch({
            type: 'FARM_ERROR'
        })
    }
}

export const removeFarm = (idFarm) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/farm/remove/' + idFarm, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'FARM_DELETE_SUCCESS',
                payload: {
                    idFarm: idFarm,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'FARM_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'FARM_ERROR'
        })
    }
}